/**
 * Header Content Data
 *
 * Static fallback for header navigation when CMS data is unavailable.
 * Follows same pattern as footer-content.ts for consistency.
 *
 * @see Story 3-6: Static Content Extraction for CMS
 */

export type NavItem = {
	name: string;
	link: string;
};

export type HeaderContent = {
	navigation: NavItem[];
	ctaButton: {
		text: string;
		link: string;
	};
};

/**
 * Header content configuration (static fallback)
 */
export const HEADER_CONTENT: HeaderContent = {
	navigation: [
		{ name: "Home", link: "/" },
		{ name: "Portfolio", link: "/portfolio" },
		{ name: "About", link: "/about" },
		{ name: "Contact", link: "/contact" },
	],
	ctaButton: {
		text: "Get In Touch",
		link: "/contact",
	},
};
